import { render } from "./CheckboxComponent.vue?vue&type=template&id=56a6adc0&scoped=true&ts=true"
import script from "./CheckboxComponent?vue&type=script&lang=ts"
export * from "./CheckboxComponent?vue&type=script&lang=ts"

import "./_assets/_checkbox.scss?vue&type=style&index=0&id=56a6adc0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a6adc0"]])

export default __exports__